<script>
import { imgHost2 } from "@/config/index";


export default {
  props: {
    planData: {
      type: Array | Object,
      default: () => []
    }
  },
  data () {
    return {
      imgHost2
    };
  }
}
</script>

<template>
  <div v-if="planData" class="care-program">
    <div class="care-program-header"></div>

    <div class="care-program-header">
      保健品方案
    </div>
    <div class="care-program-header btrr">
      安全注意事项
    </div>
    <div class="care-program-content care-program-step">
      <img :src="`${imgHost2}/ywa_pic.png`" class="care-program-step-pic" />
    </div>

    <div class="care-program-content">
      {{ planData[0].plan }}
    </div>
    <div class="care-program-content">
      {{ planData[0].precautions }}
    </div>
    <div class="care-program-content care-program-step">
      <img :src="`${imgHost2}/yq_pic.png`" class="care-program-step-pic" />
    </div>

    <div class="care-program-content">
      {{ planData[1].plan }}
    </div>
    <div class="care-program-content">
      {{ planData[1].precautions }}
    </div>
    <div class="care-program-content care-program-step">
      <img :src="`${imgHost2}/eq_pic.png`" class="care-program-step-pic" />
    </div>

    <div class="care-program-content">
      {{ planData[2].plan }}
    </div>
    <div class="care-program-content bbrr">
      {{ planData[2].precautions }}
    </div>
    <div class="care-program-content care-program-step">
      <img :src="`${imgHost2}/sq_pic.png`" class="care-program-step-pic" />
    </div>

    <div class="care-program-content">
      {{ planData[3].plan }}
    </div>
    <div class="care-program-content bbrr">
      {{ planData[3].precautions }}
    </div>
    <div class="care-program-content care-program-step">
      <img :src="`${imgHost2}/siq_pic.png`" class="care-program-step-pic" />
    </div>

    <div class="care-program-content">
      {{ planData[4].plan }}
    </div>
    <div class="care-program-content bbrr">
      {{ planData[4].precautions }}
    </div>
  </div>
  <div v-else>
    暂无癌症营养保健保健方案
  </div>
</template>

<style lang="scss" scoped>
$borderRadius: 8px;

$activeBorderColor: #6580f8;

.care-program {
  position: relative;
  width: 100%;
  display: grid;
  grid-template-columns: auto 180px 1fr;
  grid-template-rows: auto repeat(5, 1fr);

  >div {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    font-size: 16;
    font-weight: bold;

    &:not(:nth-child(3n + 1)) {
      padding: 10px 2px;
      background-color: #ebefff;
    }

    &:nth-child(2) {
      border-top: 1px solid $activeBorderColor;
      border-top-left-radius: $borderRadius;
      border-top-right-radius: $borderRadius;
      overflow: hidden;
    }

    &:nth-child(3n + 2),
    &:nth-child(3n + 3) {
      border-bottom: 1px solid #bfcdff;
    }

    &:nth-child(n + 16) {
      border-bottom: none;
    }

    &:nth-child(3n + 2) {
      border-right: 2px solid $activeBorderColor;
      border-left: 2px solid $activeBorderColor;
    }

    &:nth-last-child(2) {
      border-bottom: 4px solid $activeBorderColor;
      border-bottom-left-radius: $borderRadius;
      border-bottom-right-radius: $borderRadius;
      overflow: hidden;
    }
  }

  &-step {
    padding-right: 10px;

    &-pic {
      position: relative;
      height: 100%;
      width: 64px;
    }
  }
}

.btlr {
  border-top-left-radius: $borderRadius;
}

.btrr {
  border-top-right-radius: $borderRadius;
}

.bblr {
  border-bottom-left-radius: $borderRadius;
}

.bbrr {
  border-bottom-right-radius: $borderRadius;
}
</style>
